import $ from "jquery";

const breadCrumb = {
    methods: {
        dataLayerObj: function (e) {
            var obj = {
                'articleName': "",
                'blogCategory': "",
                'blogPageCategory': "",
                'buttonText': e,
                'pageSection': "Breadcrumb",
                'planOption': "",
                'productCategory': "",
                'productName': "",
                'question': "",
                'source': "",
                'searchTerm': "",
                'videoTitle': "",
                'bannerName': "",
            };
            return obj;
        },
        init: function () {
            $(".cmp-breadcrumb__item").on('click', (e)=>{
                let buttonText = e.currentTarget.innerText.replace(/\n/g, '').trim();
                buttonText = buttonText.substring(0, buttonText.length-2);
                let obj = this.dataLayerObj(buttonText);
                createDataLayer("buttonClick", obj);
            });
          },
    }
};
$(() => {
    if ($(".chlibreadcrumb").length > 0) {
      breadCrumb.methods.init();
    }
  });
